module.exports = __webpack_public_path__ + "static/media/bg_02@2x.41dd8ecb.png";